// Template300: Bali - Página mapa día (Page4-style)
// Cabecera verde, mapa iframe + botón Ver mapa grande + tip + sticker, intro y bloques debajo (opcional SabiasQue).

import React, { useState } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template300 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";
	const [fullscreen, setFullscreen] = useState(false);

	const headerText = page?.texts?.[0]?.content;
	const tipMap = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerMap = getImageSrc("sticker");
	const stickerLeftId = page?.data?.stickerLeftId;
	const stickerRightId = page?.data?.stickerRightId;
	const stickerLeft = stickerLeftId ? getImageSrc(stickerLeftId) : null;
	const stickerRight = stickerRightId ? getImageSrc(stickerRightId) : null;
	const mapTipLeft = page?.data?.mapTipLeft ?? tipMap;
	const mapTipRight = page?.data?.mapTipRight;
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";
	const blocks = Array.isArray(page?.data?.blocks) ? page.data.blocks : [];
	const listBox = page?.data?.listBox;
	const footerBox = page?.data?.footerBox;

	const actualHeaderColor = headerBackgroundColor || "#2F6B4F";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		marginBottom: 0.5,
		marginTop: 1,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					height: "100%",
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					data-template-header
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						flexShrink: 0,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa"
					src={mapUrl}
					style={{
						border: 0,
						flex: 1,
						width: "100%",
						height: "100%",
					}}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Mapa - ocupa todo el espacio disponible; en móvil altura mínima para que se vea bien */}
			<Box
				data-block-id="map"
				sx={{
					display: "flex",
					flexDirection: "column",
					position: "relative",
					marginTop: "-60px",
					flex: 1,
					minHeight: 0,
					...(isSmallScreen && { minHeight: "45vh" }),
				}}
			>
				<Box
					sx={{
						flex: 1,
						marginTop: "-70px",
						minHeight: 0,
						position: "relative",
						...(isSmallScreen && { minHeight: "42vh" }),
					}}
				>
					{mapUrl ? (
						<>
							<button
								onClick={() => setFullscreen(true)}
								style={{
									position: "absolute",
									top: 140,
									right: 10,
									backgroundColor: actualHeaderColor,
									color: "#fff",
									padding: "8px 10px",
									fontSize: "11px",
									borderRadius: "8px",
									fontFamily: "'Poppins', sans-serif",
									boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
									zIndex: 4,
									border: "none",
									cursor: "pointer",
								}}
							>
								Ver mapa grande
							</button>
							<iframe
								title="Mapa"
								src={mapUrl}
								width="100%"
								height="100%"
								style={{
									border: 0,
									position: "absolute",
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									minHeight: isSmallScreen ? 320 : 200,
								}}
								allowFullScreen
								loading="lazy"
							/>
						</>
					) : null}
					{/* Stickers sobre el mapa (mismo contenedor que el iframe para quedar encima) */}
					{(stickerLeft || (!stickerLeft && !stickerRight && stickerMap)) && (
						<Box
							component="img"
							src={stickerLeft || stickerMap}
							alt=""
							sx={{
								width: 110,
								position: "absolute",
								bottom: -10,
								left: -10,
								zIndex: 10,
								pointerEvents: "none",
							}}
						/>
					)}
					{stickerRight && (
						<Box
							component="img"
							src={stickerRight}
							alt=""
							sx={{
								width: 110,
								position: "absolute",
								bottom: -10,
								right: -10,
								zIndex: 10,
								pointerEvents: "none",
							}}
						/>
					)}
					{/* Tips sobre el mapa (mismo contenedor para quedar encima del iframe) */}
					{mapTipLeft && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 80 : 60,
								left: isSmallScreen ? 6 : 40,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 140,
								zIndex: 11,
							}}
						>
							{mapTipLeft}
						</Box>
					)}
					{mapTipRight && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 80 : 60,
								right: isSmallScreen ? 6 : 40,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 140,
								zIndex: 11,
							}}
						>
							{mapTipRight}
						</Box>
					)}
				</Box>
			</Box>

			{/* Intro y bloques debajo */}
			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box component="p" sx={estiloP} style={{ marginBottom: 12 }}>
						{intro}
					</Box>
				)}
				<Box data-block-id="text-2" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					{blocks.map((block, idx) => {
						const blockType = block.type || "default";
						const blockImage = block.imageId
							? getImageSrc(block.imageId)
							: null;
						const sabiasQueList = Array.isArray(block.sabiasQue)
							? block.sabiasQue
							: [];
						const stickerImage = block.stickerImageId
							? getImageSrc(block.stickerImageId)
							: null;
						const tipBox = block.tipBox;
						const tipBoxStyle = {
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px 12px 0 12px",
							padding: "10px 12px",
							fontSize: 11,
							color: contentColor,
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							zIndex: 9999,
						};

						if (blockType === "highlightedBoxWithList") {
							const items = Array.isArray(block.items) ? block.items : [];
							return (
								<Box
									key={idx}
									data-block-id={`text-${idx + 3}`}
									sx={{
										position: "relative",
										backgroundColor: "#c8e6d4",
										borderRadius: "12px",
										padding: 2.5,
										width: "100%",
										marginTop: 0,
									}}
								>
									{sabiasQueList.length > 0 &&
										sabiasQueList.map((sq, i) => (
											<Box
												key={i}
												sx={{
													position: "absolute",
													top: isSmallScreen ? -20 : -10,
													left: "35%",
												}}
											>
												<SabiasQue
													icono={sq.icono || "💬"}
													texto={sq.texto || ""}
												/>
											</Box>
										))}
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{items.length > 0 && (
										<Box
											component="ul"
											sx={{
												paddingLeft: 2.5,
												margin: 0,
												lineHeight: 1.6,
												fontSize: 13,
											}}
										>
											{items.map((item, i) => (
												<Box
													component="li"
													key={i}
													dangerouslySetInnerHTML={{ __html: item }}
												/>
											))}
										</Box>
									)}
								</Box>
							);
						}

						if (blockType === "highlightedBox") {
							const tipTopRight = block.tipBoxPosition === "topRight";
							return (
								<Box
									key={idx}
									data-block-id={`text-${idx + 3}`}
									sx={{
										position: "relative",
										backgroundColor: "#c8e6d4",
										borderRadius: "12px",
										border: tipTopRight ? "3px solid #2F6B4F" : "none",
										width: "100%",
										marginTop: isSmallScreen ? 4 : 0,
									}}
								>
									{tipBox && (tipBox.titulo || tipBox.texto) && (
										<Box
											sx={{
												position: "absolute",
												...(tipTopRight
													? { top: -40, right: 10, maxWidth: 140 }
													: {
															bottom: isSmallScreen ? 110 : 60,
															right: 10,
															maxWidth: 250,
														}),
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "12px 12px 0px 12px",
												padding: "10px 12px",
												fontSize: 11,
												color: contentColor,
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												zIndex: 9999,
											}}
										>
											{tipBox.titulo && <strong>{tipBox.titulo}</strong>}{" "}
											{tipBox.texto}
										</Box>
									)}
									{stickerImage && (
										<Box
											component="img"
											src={stickerImage}
											alt=""
											sx={{
												width: 110,
												position: "absolute",
												...(tipTopRight
													? { top: 20, right: -20 }
													: { bottom: isSmallScreen ? 50 : -10, right: -30 }),
											}}
										/>
									)}
									<Box
										sx={{
											...estiloP,
											padding: 2.5,
											width: idx === 0 ? "100%" : "70%",
										}}
									>
										{block.titulo && (
											<Box
												component="h3"
												sx={{ ...estiloH3, marginBottom: 0, marginTop: 0 }}
											>
												{block.titulo}
											</Box>
										)}
										{block.contenido}
									</Box>
								</Box>
							);
						}

						return (
							<Box
								key={idx}
								data-block-id={`text-${idx + 3}`}
								sx={{
									display: "flex",
									gap: 2.5,
									alignItems: "flex-start",
									position: "relative",
								}}
							>
								{blockImage && (
									<Box
										component="img"
										src={blockImage}
										alt=""
										sx={{
											width: "40%",
											height: 110,
											borderRadius: "12px",
											objectFit: "cover",
											flexShrink: 0,
										}}
									/>
								)}
								{sabiasQueList.length > 0 &&
									sabiasQueList.map((sq, i) => (
										<Box
											key={i}
											sx={{
												position: "absolute",
												top: i * 40,
												left: "35%",
											}}
										>
											<SabiasQue
												icono={sq.icono || "💬"}
												texto={sq.texto || ""}
											/>
										</Box>
									))}
								<Box
									sx={{
										position: "relative",
									}}
								>
									{block.titulo && (
										<Box component="h3" sx={estiloH3}>
											{block.titulo}
										</Box>
									)}
									{block.contenido && (
										<Box component="p" sx={estiloP}>
											{block.contenido}
										</Box>
									)}
								</Box>
							</Box>
						);
					})}
				</Box>
				{listBox &&
					listBox.titulo &&
					Array.isArray(listBox.items) &&
					listBox.items.length > 0 && (
						<Box
							sx={{
								backgroundColor: "#c8e6d4",
								border: "3px solid #2F6B4F",
								borderRadius: "12px",
								padding: "8px 12px",
								fontSize: 14,
								color: "#333",
								marginTop: 2,
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontWeight: 700,
									color: "#2F6B4F",
									textTransform: "uppercase",
								}}
							>
								{listBox.titulo}
							</Box>
							<Box
								component="ul"
								sx={{
									margin: 0,
									paddingLeft: 2.5,
									lineHeight: 1.5,
									fontSize: 13,
								}}
							>
								{listBox.items.map((item, i) => (
									<Box
										component="li"
										key={i}
										dangerouslySetInnerHTML={{ __html: item }}
									/>
								))}
							</Box>
						</Box>
					)}
				{footerBox?.content && (
					<Box
						data-block-id="text-footer"
						sx={{
							backgroundColor: "#c8e6d4",
							border: "3px solid #2F6B4F",
							borderRadius: "12px",
							padding: "12px 16px",
							fontSize: 13,
							color: "#333",
							width: isSmallScreen ? "60%" : "100%",
							marginTop: 2,
						}}
					>
						<Box component="p" sx={estiloP}>
							{footerBox.content}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template300.thumbnail = "/images/template-1.png";
export default Template300;
